import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class Scroll {

    constructor($el, $appear) {
        this.$el = $el;
        this.$appear = $appear;
        this.init();
    }

    init = () => {
        this.fadeIn();
        this.appear();



    }

    fadeIn = () => {
        this.$el.each((i, el) => {
            gsap.to(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 90%",
                },
                duration: 1,
                x: 0,
                opacity: 1,
                ease: "power2.inOut"
            });
        })
    }

    appear = () => {
        this.$appear.each((i, el) => {
            gsap.to(el,  {
                scrollTrigger: {
                    trigger: el,
                    start: "top 90%",
                },
                duration: 1,
                opacity: 1,
                ease:"power2.inOut",
            })
        })
    }
}

export default Scroll;


